import { render, staticRenderFns } from "./foodLog.vue?vue&type=template&id=31b682c2&scoped=true&"
import script from "./foodLog.vue?vue&type=script&lang=js&"
export * from "./foodLog.vue?vue&type=script&lang=js&"
import style0 from "./foodLog.vue?vue&type=style&index=0&id=31b682c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b682c2",
  null
  
)

export default component.exports